import chat from "../../../views/pages/topic/chat.vue";
import topic from "../../../views/pages/topic/topics.vue";

export default [
  {
    path: "topic",
    name: "topic",
    component: topic,
    meta: {
      headerClass: "header",
      sidebarClass: "",
      auth_roles: ["pos_hub_manager"],
      auth_type: ["user"],
    },
  },
  {
    path: "topic/:topic_id",
    name: "chat",
    component: chat,
    meta: {
      headerClass: "header",
      sidebarClass: "",
      auth_roles: ["pos_hub_manager"],
      auth_type: ["user"],
    },
  },
];
